import { Container, Box, Typography, Button } from '@mui/material';

const CustomButtonSelector = ({
  title,
  options = [],
  selected,
  setSelected,
  onConfirm,
  multiple = false,
}) => {
  const isSelected = multiple ? selected.length > 0 : !!selected;

  const handleClick = (id) => {
    if (multiple) {
      if (selected.includes(id)) {
        setSelected(selected.filter((i) => i !== id));
      } else {
        setSelected([...selected, id]);
      }
    } else {
      setSelected(id);
    }
  };

  const isOptionSelected = (id) =>
    multiple ? selected.includes(id) : selected === id;

  return (
    <Container>
      <Box mt={10} textAlign="center">
        <Typography variant="h5" gutterBottom>{title}</Typography>
      </Box>

      <Container maxWidth="xs">
        <Box mt={4} display="flex" flexDirection="column" gap={2}>
          {options.map((opt) => (
            <Button
              key={opt.id}
              variant="contained"
              onClick={() => handleClick(opt.id)}
              fullWidth
              startIcon={opt.icon || null}
              sx={{
                height: 60,
                fontSize: '1rem',
                fontWeight: 'bold',
                backgroundColor: isOptionSelected(opt.id) ? '#1976d2' : '#9e9e9e',
                color: '#fff',
                '&:hover': {
                  backgroundColor: isOptionSelected(opt.id) ? '#1565c0' : '#757575',
                },
              }}
            >
              {opt.label}
            </Button>
          ))}
        </Box>

        <Box mt={5}>
          <Button
            variant="contained"
            color="primary"
            onClick={onConfirm}
            fullWidth
            disabled={!isSelected}
            sx={{
              height: 60,
              fontSize: '1rem',
              fontWeight: 'bold',
            }}
          >
            Confirmar
          </Button>
        </Box>
      </Container>
    </Container>
  );
};

export default CustomButtonSelector;